/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kept`)
};

const es_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} mantenidas`)
};

const de_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} behalten`)
};

const nl_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} behouden`)
};

const fr_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} conservées`)
};

const it_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} mantenute`)
};

const pt_br2_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} mantidas`)
};

const pt_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} mantidas`)
};

const ja_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}件保持`)
};

const zh_rd_kept = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保留 ${i?.n} 行`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ n: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_kept = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_kept(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_kept", locale)
	if (locale === "en") return en_rd_kept(inputs)
	if (locale === "es") return es_rd_kept(inputs)
	if (locale === "de") return de_rd_kept(inputs)
	if (locale === "nl") return nl_rd_kept(inputs)
	if (locale === "fr") return fr_rd_kept(inputs)
	if (locale === "it") return it_rd_kept(inputs)
	if (locale === "pt-BR") return pt_br2_rd_kept(inputs)
	if (locale === "pt") return pt_rd_kept(inputs)
	if (locale === "ja") return ja_rd_kept(inputs)
	return zh_rd_kept(inputs)
};